import React from 'react'

interface MetaLineProps {
  label: string
  value: string
  className?: string
  labelClassName?: string
  valueClassName?: string
}

export function SignatoryMetaLine({
  label,
  value,
  className = '',
  labelClassName = 'w-[2.8rem] shrink-0',
  valueClassName = 'min-w-0 flex-1 break-words'
}: MetaLineProps) {
  return (
    <div className={`flex leading-tight ${className}`}>
      <span className={labelClassName}>{label}:</span>
      <span className={valueClassName}>{value.trim() ? value : '\u2014'}</span>
    </div>
  )
}

interface SignatoryMetaLinesProps {
  name: string
  title?: string
  date?: string
  className?: string
  lineClassName?: string
}

export default function SignatoryMetaLines({
  name,
  title,
  date,
  className = 'space-y-0.5',
  lineClassName = 'text-[length:var(--wps-font-size-micro,11px)] text-black'
}: SignatoryMetaLinesProps) {
  return (
    <div className={className}>
      <SignatoryMetaLine label="Name" value={name} className={lineClassName} />
      <SignatoryMetaLine label="Title" value={title ?? ''} className={lineClassName} />
      <SignatoryMetaLine label="Date" value={date ?? ''} className={lineClassName} />
    </div>
  )
}
